/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CloneScorecardTemplateRequest
 */
export interface CloneScorecardTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CloneScorecardTemplateRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the CloneScorecardTemplateRequest interface.
 */
export function instanceOfCloneScorecardTemplateRequest(value: object): boolean {
    return true;
}

export function CloneScorecardTemplateRequestFromJSON(json: any): CloneScorecardTemplateRequest {
    return CloneScorecardTemplateRequestFromJSONTyped(json, false);
}

export function CloneScorecardTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloneScorecardTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CloneScorecardTemplateRequestToJSON(value?: CloneScorecardTemplateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

